module.exports = __webpack_public_path__ + "05b5843ee0b50d6a79615ae185edb243.svg";